import { useEffect, useRef } from 'react';

const mediaLogos = [
  { src: 'https://rentfi.b-cdn.net/rentfi-thenewyorktimes.svg', alt: 'The New York Times Logo', width: 120, height: 50 },
  { src: 'https://rentfi.b-cdn.net/rentfi-cryptodaily.svg', alt: 'Crypto Daily Logo', width: 120, height: 50 },
  { src: 'https://rentfi.b-cdn.net/rentfi-businessinsider.svg', alt: 'Business Insider Logo', width: 120, height: 50 },
  { src: 'https://rentfi.b-cdn.net/rentfi-beIncrypto.svg', alt: 'BeInCrypto Logo', width: 120, height: 50 },
  { src: 'https://rentfi.b-cdn.net/rentfi-yahoo.svg', alt: 'Yahoo Finance Logo', width: 120, height: 50 },
  { src: 'https://rentfi.b-cdn.net/rentfi-cryptopolitan.svg', alt: 'Cryptopolitan Logo', width: 120, height: 50 },
  { src: 'https://rentfi.b-cdn.net/rentfi-marketwatch.svg', alt: 'MarketWatch Logo', width: 120, height: 50 },
  { src: 'https://rentfi.b-cdn.net/rentfi-finbold.svg', alt: 'Finbold Logo', width: 120, height: 50 },
  { src: 'https://rentfi.b-cdn.net/rentfi-morningstar.svg', alt: 'Morningstar Logo', width: 120, height: 50 },
  { src: 'https://rentfi.b-cdn.net/rentfi-thenewscrypto.svg', alt: 'The News Crypto Logo', width: 120, height: 50 },
  { src: 'https://rentfi.b-cdn.net/rentfi-cbs.svg', alt: 'CBS News Logo', width: 120, height: 50 },
  { src: 'https://rentfi.b-cdn.net/rentfi-cointelegraph.svg', alt: 'CoinTelegraph Logo', width: 120, height: 50 },
  { src: 'https://rentfi.b-cdn.net/rentfi-nbc.svg', alt: 'NBC News Logo', width: 120, height: 50 },
  { src: 'https://rentfi.b-cdn.net/rentfi-theeconomictimes.svg', alt: 'The Economic Times Logo', width: 120, height: 50 },
  { src: 'https://rentfi.b-cdn.net/rentfi-fox.svg', alt: 'Fox Business Logo', width: 120, height: 50 },
  { src: 'https://rentfi.b-cdn.net/rentfi-investing.svg', alt: 'Investing.com Logo', width: 120, height: 50 },
  { src: 'https://rentfi.b-cdn.net/rentfi-benzinga.svg', alt: 'Benzinga Logo', width: 120, height: 50 },
  { src: 'https://rentfi.b-cdn.net/rentfi-abc.svg', alt: 'ABC News Logo', width: 120, height: 50 }
];

export default function MediaSlider() {
  const sliderRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const slider = sliderRef.current;
    if (!slider) return;

    const firstSet = slider.children[0].cloneNode(true) as HTMLElement;
    slider.appendChild(firstSet);
    
    const itemWidth = slider.children[0].scrollWidth;
    let position = 0;
    
    function animate() {
      position -= 1.5;
      
      if (position <= -itemWidth) {
        position = 0;
      }
      
      if (slider) {
        slider.style.transform = `translateX(${position}px)`;
      }
      requestAnimationFrame(animate);
    }

    requestAnimationFrame(animate);
  }, []);

  return (
    <section className="py-16 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-12 sm:px-16 lg:px-20">
        <div className="text-center mb-12">
          <h2 className="text-primary">Featured In</h2>
        </div>

        <div className="relative overflow-hidden">
          <div 
            ref={sliderRef}
            className="flex transition-transform duration-0"
            style={{ willChange: 'transform' }}
          >
            <div className="flex items-center" style={{ gap: '64px' }}>
              {mediaLogos.map((logo, index) => (
                <div
                  key={`${logo.alt}-${index}`}
                  className="w-32 h-[50px] shrink-0 grayscale hover:grayscale-0 transition-all duration-300 px-2"
                >
                  <img
                    src={logo.src}
                    alt={logo.alt}
                    className="w-full h-full object-contain"
                    loading="lazy"
                    width={logo.width}
                    height={logo.height}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}